import React, { useCallback, useMemo } from "react";
import { useStore } from "stores/connect";
import ExpandedConfigurationSection from "./expanded-sections/ExpandedConfigurationSection";
import MessagesPerStreamSection from "./expanded-sections/MessagesPerStreamSection";
import AssociatedStreamsSection from "./expanded-sections/AssociatedStreamsSection";
import { METRIC_COLUMN_IDS, METRIC_COLUMN_TITLES } from "./metricColumns";
import ForwarderInputTypesStore from "../stores/ForwarderInputTypesStore";
const useTableElements = () => {
  const { forwarderInputDescriptions } = useStore(ForwarderInputTypesStore);
  const renderExpandedConfigurationDetails = useCallback(
    (input) => /* @__PURE__ */ React.createElement(ExpandedConfigurationSection, { input, inputDescriptions: forwarderInputDescriptions }),
    [forwarderInputDescriptions]
  );
  const expandedSections = useMemo(
    () => ({
      configuration: {
        title: "Configuration",
        content: renderExpandedConfigurationDetails
      },
      [METRIC_COLUMN_IDS.messagesPerStream]: {
        title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.messagesPerStream],
        content: (input) => /* @__PURE__ */ React.createElement(MessagesPerStreamSection, { input })
      },
      [METRIC_COLUMN_IDS.associatedStreams]: {
        title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.associatedStreams],
        content: (input) => /* @__PURE__ */ React.createElement(AssociatedStreamsSection, { input })
      }
    }),
    [renderExpandedConfigurationDetails]
  );
  return { expandedSections };
};
export default useTableElements;
